import { BorrowerOnboardingDetails, Income } from '@nemuru-eng/js-api-client';

import { OtherIncomeDeclaredData } from '@/components/modules/DocumentsValidation/components/steps/IncomeValidation/components/OtherIncomeDeclaredData';
import { WorkerIncomeDeclaredData } from '@/components/modules/DocumentsValidation/components/steps/IncomeValidation/components/WorkerIncomeDeclaredData';
import { EMPLOYMENT_STATUS_FILTER } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/ProfessionalDetailsSection/constants';

export interface IncomeDeclaredDataProps {
  borrowerOnboardingDetails: BorrowerOnboardingDetails;
  income: Income;
}
export const IncomeDeclaredDataFactory = ({ borrowerOnboardingDetails, income }: IncomeDeclaredDataProps) => {
  const employmentStatus = borrowerOnboardingDetails.userDetails?.professionalDetails?.employmentStatus;

  if (!employmentStatus) {
    throw new Error('Not able to find necessary userDetails.professionalDetails data to validate income');
  }

  if (EMPLOYMENT_STATUS_FILTER.includes(employmentStatus)) {
    return <WorkerIncomeDeclaredData borrowerOnboardingDetails={borrowerOnboardingDetails} income={income} />;
  }

  return <OtherIncomeDeclaredData borrowerOnboardingDetails={borrowerOnboardingDetails} income={income} />;
};
